<template>
    <div id="formblock">
        <el-form label-position="top" label-width="80px" :model="searchForm">
            <el-row :gutter="30">
                <el-col :span="5">
                    <el-form-item label="表單名稱">
                        <el-input v-model="searchForm.DOC_NAME"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="5">
                    <el-form-item label="限定廠商">
                        <el-input v-model="searchForm.OUTLET_NAME"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="6">
                    <el-form-item label="啟用日期">
                        <el-date-picker v-model="searchForm.DATE" type="daterange" range-separator="~" start-placeholder="" end-placeholder="" />
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>
        <el-row type="flex" justify="center">
            <el-col :span="6" style="margin-top:auto;margin-bottom:auto;">
                <el-button style="width: 100%" type="primary" @click="onSearch" v-show="store.getters.check_auth('SEARCH')">Search</el-button>
            </el-col>
        </el-row>
    </div>
    <div id="datablock">
        <el-row type="flex" justify="space-between">
            <el-select v-model="pageValue" placeholder="" @@change="onSelectPage()">
                <el-option v-for="item in pageOptions"
                           :key="item.value"
                           :label="item.label"
                           :value="item.value">
                </el-option>
            </el-select>
            <el-button type="primary" round plain @click="onAddClick()" v-show="store.getters.check_auth('ADD')">新增</el-button>
        </el-row>

        <div ref="table" style="margin-top:10px;"></div>
    </div>

    <!--新增/編輯-->
    <el-dialog :title="dialogTitle" width="40%" v-model="dialogFormVisible" top="1vh"
               @opened="onDialogOpen" @closed="onDialogClose" center :lock-scroll="false" :close-on-click-modal="false">
        <el-form :model="form" :rules="rules" ref="formRef" :inline-message="true" label-position="top">
            <el-scrollbar wrap-style="overflow-x:hidden;">
                <el-row>
                    <el-col :span="24" style="padding: 0 6px;">
                        <el-form-item label="表單名稱" prop="DOC_NAME">
                            <el-input v-model="form.DOC_NAME" maxlength="50"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12" style="padding: 0 6px;">
                        <el-form-item label="表單類別" prop="DOC_TYPE">
                            <el-input v-model="form.DOC_TYPE" maxlength="30"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12" style="padding: 0 6px;">
                        <el-form-item label="版本編號" prop="VSN_NO">
                            <el-input v-model="form.VSN_NO" maxlength="20"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12" style="padding: 0 6px;">
                        <el-form-item label="限定品牌/門電/公司" prop="OUTLET_NAME">
                            <el-input v-model="form.OUTLET_NAME" maxlength="100"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12" style="padding: 0 6px;">
                        <el-form-item label="顯示順序" prop="ORD_FG">
                            <el-input v-model="form.ORD_FG" maxlength="5"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12" style="padding: 0 6px;">
                        <el-form-item label="啟用日期" prop="START_DATE">
                            <el-date-picker v-model="form.START_DATE"
                                            type="date"
                                            placeholder=""
                                            style="width:100%;"
                                            value-format="YYYY/MM/DD" :clearable=false />
                        </el-form-item>
                    </el-col>
                    <el-col :span="12" style="padding: 0 6px;">
                        <el-form-item label="停用日期" prop="STOP_DATE">
                            <el-date-picker v-model="form.STOP_DATE"
                                            type="date"
                                            placeholder=""
                                            style="width:100%;"
                                            value-format="YYYY/MM/DD" :clearable=true />
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <label class="el-form-item__label">選取檔案</label>
                            <el-upload ref="upload"
                                       class="upload-demo"
                                       action=""
                                       :limit="1"
                                       :auto-upload="false"
                                       :on-change="onFileChange"
                                       :on-remove="onFileRemove"
                                       :file-list="form.FILE_LIST">
                                <template #trigger>
                                    <el-button type="primary" size="mini">Select File</el-button>
                                </template>
                            </el-upload>
                    </el-col>
                </el-row>
                <el-row :gutter="10">
                    <el-col>
                        <el-form-item label="文件修改說明" prop="AMEND_NOTES">
                            <el-input type="textarea" v-model="form.AMEND_NOTES" rows="3"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="10">
                    <el-col>
                        <el-form-item label="Remarks" prop="REMARKS">
                            <el-input type="textarea" v-model="form.REMARKS" rows="3"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row v-show="IDdisabled">
                    <el-col :span="3" style="padding: 0 6px;">
                        <el-text class="mx-1">建檔人</el-text>
                    </el-col>
                    <el-col :span="9" style="padding: 0 6px;">
                        <el-text class="mx-1">{{ form.CREATE_USER }}</el-text>
                    </el-col>
                    <el-col :span="3" style="padding: 0 6px;">
                        <el-text class="mx-1">修改人</el-text>
                    </el-col>
                    <el-col :span="9" style="padding: 0 6px;">
                        <el-text class="mx-1">{{ form.EDIT_USER }}</el-text>
                    </el-col>
                </el-row>
                <el-row v-show="IDdisabled">
                    <el-col :span="9" :offset="3" style="padding: 0 6px;">
                        <el-text class="mx-1">{{ form.CREATE_TIME }}</el-text>
                    </el-col>
                    <el-col :span="9" :offset="3" style="padding: 0 6px;">
                        <el-text class="mx-1">{{ form.EDIT_TIME }}</el-text>
                    </el-col>
                </el-row>
            </el-scrollbar>
        </el-form>
        <template #footer class="dialog-footer">
            <el-button type="info" @click="dialogFormVisible = false" style="width: 150px;">取消</el-button>
            <el-button type="primary" @click="onSubmit('form')" style="width: 150px;">存檔</el-button>
        </template>
    </el-dialog>
</template>

<script setup>
    import { ref, reactive, onBeforeMount, onMounted, nextTick } from 'vue';
    import { TabulatorFull as Tabulator } from 'tabulator-tables'; //import Tabulator library
    import { ElMessage, ElMessageBox } from 'element-plus'
    import $api from '@/utils/axios';
    import { useDownload } from '@/composables/download'
    import { useStore } from "vuex";
    const store = useStore();

    const dialogTitle = ref('');//角色資料dialog標題
    const dialogFormVisible = ref(false);//顯示dialog
    const IDdisabled = ref(false);//編輯時ID狀態
    const addOrEdit = ref('');
    const formRef = ref(null);
    const formData = ref(null);
    const pageValue = ref(25);

    const pageOptions = reactive([
        { value: 25, label: '一頁顯示25筆資料' },
        { value: 50, label: '一頁顯示50筆資料' }]);

    const upload = ref(null);

    const searchForm = ref({
        DOC_NAME: '',
        OUTLET_NAME: '',
        DATE: [],
        START_DATE: '',
        END_DATE: ''
    });

    const form = ref({
        DOC_SEQ: '',
        DOC_NAME: '',
        DOC_TYPE: '',
        VSN_NO: '',
        OUTLET_NAME: '',
        ORD_FG: '',
        START_DATE: '',
        STOP_DATE: '',
        AMEND_NOTES: '',
        REMARKS: '',
        CREATE_USER: '',
        CREATE_TIME: '',
        EDIT_USER: '',
        EDIT_TIME: '',
        FILE_LIST: [],//編輯顯示用
        FILE: null
    });

    const rules = reactive({
        DOC_NAME: [{ required: true, message: '請輸入表單名稱', trigger: 'blur' }],
        DOC_TYPE: [{ required: true, message: '請輸入表單類別', trigger: 'blur' }],
        VSN_NO: [{ required: true, message: '請輸入版本編號', trigger: 'blur' }],
        START_DATE: [{ required: true, message: '請選擇啟用日期', trigger: 'blur' }]
    });

    const table = ref(null); //reference to your table element
    const tabulator = ref(null); //variable to hold your table

    const onLoadTable = () => {
        if (searchForm.value.DATE.length != 0) {
            searchForm.value.START_DATE = searchForm.value.DATE[0].toLocaleString('default', { year: "numeric", month: "2-digit", day: "2-digit" });
            searchForm.value.END_DATE = searchForm.value.DATE[1].toLocaleString('default', { year: "numeric", month: "2-digit", day: "2-digit" });
        } else {
            searchForm.value.START_DATE = '';
            searchForm.value.END_DATE = '';
        }

        $api.GET('/api/DocSet/GetTableData', searchForm.value
        ).then((response) => {
            console.log(response);
            tabulator.value.setData(response);
        });
    }

    const onSearch = () => {
        onLoadTable();
    }

    const onDialogOpen = () => {
        nextTick(() => {
            if (addOrEdit.value == 'edit') {
                form.value = formData.value;
            }
        })
    }
    const onDialogClose = () => {
        formRef.value.resetFields();
        upload.value.clearFiles();
        form.value.FILE_LIST = [];
    }

    const onFileChange = (file) => {
        form.value.FILE = file.raw;
    }
    const onFileRemove = (file) => {
        form.value.FILE = null;
    }

    const onAddClick = () => {
        IDdisabled.value = false;
        addOrEdit.value = 'add';
        dialogFormVisible.value = true;
        dialogTitle.value = '[新增]';
    }

    const onEditClick = (e, cell) => {
        let data = cell.getData();
        formData.value = JSON.parse(JSON.stringify(data));
        formData.value.FILE_LIST = [];
        if (data.DOC_FILE) {
            let fileExt = data.DOC_FILE.split('.')[1];
            formData.value.FILE_LIST.push({
                id: data.DOC_SEQ,
                name: `${data.DOC_TYPE}_${data.DOC_NAME}_${data.VSN_NO}.${fileExt}`,
                status: 'success'
            });
        }

        IDdisabled.value = true;
        addOrEdit.value = 'edit';
        dialogFormVisible.value = true;
        dialogTitle.value = '[編輯]';
    }

    const onDownloadClick = (e, cell) => {
        let data = cell.getData();
        if (!data.DOC_FILE) return;

        let docSeq = data.DOC_SEQ;

        useDownload('/api/DocSet/Download?DOC_SEQ=' + docSeq, `${data.DOC_TYPE}_${data.VSN_NO}_${data.DOC_NAME}.${data.DOC_FILE.split('.')[1]}`);
    }

    const onDeleteClick = (e, cell) => {
        ElMessageBox.confirm('確定要刪除?', '提示', {
            confirmButtonText: '確認',
            cancelButtonText: '取消',
            type: 'warning',
        }).then(() => {
            $api.POST('/api/DocSet/Delete',
                cell.getData(),
            ).then((res) => {
                ElMessageBox.alert('刪除成功!', '提示', {
                    confirmButtonText: '確定',
                    callback: action => {
                        onLoadTable();
                    }
                });
            });
        });
    }

    const onSubmit = () => {
        formRef.value.validate((valid) => {
            if (valid) {
                var postForm = new FormData();//需用FormData才能攜帶檔案
                Object.entries(form.value).forEach(([key, value]) => {//將form內資料放入FormData
                    if (value) postForm.append(key, value);
                });

                if (addOrEdit.value == 'add') {
                    $api.UPLOAD('/api/DocSet/Add', postForm
                    ).then((res) => {
                        ElMessageBox.alert('新增成功!', '提示', {
                            confirmButtonText: '確定',
                            callback: action => {
                                dialogFormVisible.value = false;
                                onLoadTable();
                            }
                        });
                    }).catch(() => {
                        ElMessageBox.alert('新增失敗', '提示', {
                            confirmButtonText: '確定'
                        });
                    });
                } else if (addOrEdit.value == 'edit') {
                    $api.UPLOAD('/api/DocSet/Edit', postForm
                    ).then((res) => {
                        if (res > 0) {
                            ElMessageBox.alert('修改成功!', '提示', {
                                confirmButtonText: '確定',
                                callback: action => {
                                    dialogFormVisible.value = false;
                                    onLoadTable();
                                }
                            });
                        } else {
                            ElMessageBox.alert('修改失敗', '提示', {
                                confirmButtonText: '確定'
                            });
                        }
                    });
                }
            }
        })
    }

    const onSelectPage = () => {
        tabulator.setPageSize(pageValue.value);
    }

    const editIcon = (cell, formatterParams) => {
        return '<i class="el-icon"><svg viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg"><path d="m199.04 672.64 193.984 112 224-387.968-193.92-112-224 388.032zm-23.872 60.16 32.896 148.288 144.896-45.696L175.168 732.8zM455.04 229.248l193.92 112 56.704-98.112-193.984-112-56.64 98.112zM104.32 708.8l384-665.024 304.768 175.936L409.152 884.8h.064l-248.448 78.336L104.32 708.8zm384 254.272v-64h448v64h-448z" fill="currentColor"></path></svg></i>';
    }
    const downloadIcon = (cell, formatterParams) => {
        if (cell.getData().DOC_FILE)
            return '<i class="el-icon"><svg viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg" data-v-ea893728=""><path fill="currentColor" d="M160 832h704a32 32 0 1 1 0 64H160a32 32 0 1 1 0-64zm384-253.696 236.288-236.352 45.248 45.248L508.8 704 192 387.2l45.248-45.248L480 584.704V128h64v450.304z"></path></svg></i>';
        else
            return '';
    }
    const deleteIcon = (cell, formatterParams) => {
        return '<i class="el-icon"><svg viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg" data-v-ea893728=""><path fill="currentColor" d="M352 192V95.936a32 32 0 0 1 32-32h256a32 32 0 0 1 32 32V192h256a32 32 0 1 1 0 64H96a32 32 0 0 1 0-64h256zm64 0h192v-64H416v64zM192 960a32 32 0 0 1-32-32V256h704v672a32 32 0 0 1-32 32H192zm224-192a32 32 0 0 0 32-32V416a32 32 0 0 0-64 0v320a32 32 0 0 0 32 32zm192 0a32 32 0 0 0 32-32V416a32 32 0 0 0-64 0v320a32 32 0 0 0 32 32z"></path></svg></i>';
    }

    onBeforeMount(() => {
        
    });

    onMounted(() => {
        //instantiate Tabulator when element is mounted
        tabulator.value = new Tabulator(table.value, {
            locale: "zh-tw",
            layout: "fitColumns",      //fit columns to width of table
            maxHeight: "calc(100vh - 392px)", //do not let table get bigger than the height of its parent element
            columnHeaderVertAlign: "middle", //align header contents to middle of cell
            pagination: "local",       //paginate the data
            paginationSize: 25,         //allow 20 rows per page of data
            columns: [
                { title: "序號", formatter: "rownum", width: 50, headerHozAlign: "center", hozAlign: "center", headerSort: false },
                { title: "表單類別", field: "DOC_TYPE", headerHozAlign: "center", hozAlign: "center", headerSort: false },
                { title: "表單名稱", field: "DOC_NAME", headerHozAlign: "center", hozAlign: "center", headerSort: false },
                { title: "版本編號", field: "VSN_NO", headerHozAlign: "center", hozAlign: "center", headerSort: false },
                { title: "限定公司", field: "OUTLET_NAME", headerHozAlign: "center", hozAlign: "center", headerSort: false },
                { title: "啟用日", field: "START_DATE", headerHozAlign: "center", hozAlign: "center", headerSort: false },
                { title: "停用日", field: "STOP_DATE", headerHozAlign: "center", hozAlign: "center", headerSort: false },
                { title: "檔案", field: "download", formatter: downloadIcon, width: 50, headerHozAlign: "center", hozAlign: "center", headerSort: false, cellClick: onDownloadClick },
                { title: "編輯", field: "edit", formatter: editIcon, width: 50, headerHozAlign: "center", hozAlign: "center", headerSort: false, cellClick: onEditClick },
                { title: "刪除", field: "delete", formatter: deleteIcon, width: 50, headerHozAlign: "center", hozAlign: "center", headerSort: false, cellClick: onDeleteClick },
            ],
            langs: {
                "zh-tw": {
                    "pagination": {
                        "page_size": "選擇筆數",
                        "first": "第一頁",
                        "last": "最後一頁",
                        "prev": "上一頁",
                        "next": "下一頁",
                    }
                }
            },
        });
        tabulator.value.on("tableBuilt", function () {
            if (!store.getters.check_auth('MODIFY')) {
                tabulator.value.hideColumn('edit');
            }
            if (!store.getters.check_auth('DEL')) {
                tabulator.value.hideColumn('delete');
            }
        });
    })

</script>

